import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import AddVendorAddress from "../AddVendorDetails/AddVendorAddress";
import AddVendorOtherDetails from "../AddVendorDetails/AddVendorOtherDetails";
import AddVendorBankDetails from "../AddVendorDetails/AddVendorBankDetails";
import AddVendorContactDetails from "../AddVendorDetails/AddVendorContactDetails";
import VendorTermsConditions from "../AddVendorDetails/VendorTermsConditions";
import "./AddVendorDetails_Admin.css";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import MiniDrawer from "../MiniDrawer/MiniDrawer";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";

const baseAPI = process.env.REACT_APP_API_URL;

const AddVendorDetails = () => {
  const [searchParm] = useSearchParams();
  const [filledData, setFilledData] = useState(null);
  const [authorized, setAuthorized] = useState(false);
  const [isEditMode, setIsEditMode] = useState(true);
  const [dataPresent, setDataPresent] = useState(false);
  const [displayName, setDisplayName] = useState([]);
  const[formSubmitted,setFormSubmitted]=useState(null)
  const [vendorCategory, setVendorCategory] = useState([]);
  const [vendorNameEmail, setVendorNameEmail] = useState({
    firstName: "",
    lastName: "",
    email: "",
  });
  const [showDetailForms, setShowDetailForms] = useState({
    AddressForm: true,
    OtherDetailsForm: false,
    BankDetailsForm: false,
    ContactDetailsForm: false,
    TermsForm: false,
  });
  const [formData, setFormData] = useState({
    Vendor_Id: 0,
    CompanyName: "",
    DisplayName: "",
    VendorCategory: "",
    Phone1: "",
    Phone2: "",
    VendorGUID: "",
    CreatedBy: "Admin",
    ModifiedBy: "Admin",
  });

  useEffect(() => {
    if (searchParm.get("vendorID") != null) {
      setFormData({
        ...formData,
        VendorGUID: searchParm.get("vendorID"),
      });
      GetVendorCategory();
      getVendorNameEmail(searchParm.get("vendorID"));
      // getDisplayName()
    }
  }, []);

  function GetVendorCategory() {
    axios
      .get(`${baseAPI}Admin/GetVendorCategory`, {
        // headers: {
        //   Authorization: `Bearer ${storedToken}`,
        // },
      })
      .then((response) => {
        setVendorCategory(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  const showClickedForm = (formName) => {
    const newObj = {
      AddressForm: false,
      OtherDetailsForm: false,
      BankDetailsForm: false,
      ContactDetailsForm: false,
      TermsForm: false,
    };

    newObj[formName] = true;
    setShowDetailForms(newObj);
  };

  // function getDisplayName(){
  //   axios.get(`${baseAPI}Admin/GETVendorDisplayName`, {}).then((response) => {
  //     setDisplayName(response.data.data);
  //   });
  // }

  function getCurrentVendorCategory(id) {    
    if (vendorCategory.length !== 0) {
      const category = vendorCategory.find((cat) => cat.Tseed == id);
      if (category !== undefined) {       
        setFormData({
          ...formData,
          VendorCategory: category.Category_Name,
        });
      }
    }
  }

  function getVendorNameEmail(id) {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}admin/GETSupplier?SupplierID=${id}`)
      .then((response) => {
        if (searchParm.get("vendorID") === response.data.data[0].VendorGUID) {
          setAuthorized(true);
        }
        setFormSubmitted(response.data.data[0].FormSubmitted)
        setVendorNameEmail({
          firstName: response.data.data[0].VendorFirstName,
          lastName: response.data.data[0].VendorLastName,
          email: response.data.data[0].VendorEmail,
        });
        if (response.data.data[0].CompanyName != null) {
          setFormData(response.data.data[0]);
          setDataPresent(true);
          setFilledData(response.data.data);
          setIsEditMode(false);
        } else {
          setFormData({
            ...formData,
            VendorCategory: response.data.data[0].VendorCategory,
            VendorGUID: searchParm.get("vendorID"),
          });
        }
        // getCurrentVendorCategory(response.data.data[0].VendorCategory)
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  const handleChange = (e) => {
    if (isEditMode) {
      const { name, value } = e.target;
      if (name === "CompanyName") {
        setFormData((prevFormData) => ({
          ...prevFormData,
          DisplayName: value,
        }));
      }
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };

  const validatePhoneNumber = (phoneNumber) => {
    const personalPhoneRegex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
    const workPhoneRegex =
      /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})(?: *x(\d+))?$/;

    return (
      personalPhoneRegex.test(phoneNumber) || workPhoneRegex.test(phoneNumber)
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let updatedForm = {};
    if (formData.Vendor_Id !== 0) {
      updatedForm = {
        ...formData,
        DisplayName: formData.CompanyName,
        ModifiedBy: "Admin",
      };
    } else {
      updatedForm = {
        ...formData,
        DisplayName: formData.CompanyName,
      };
    }
    for (const key in formData) {
      if(key!=="Phone2"){
      if (formData[key] === "") {
        alert("All fields are mandatory. Please fill out all fields.");
        return;
      }
      }                                                                                                                                         
    }

    if (!validatePhoneNumber(formData.Phone1)) {
      alert("Please enter a valid phone number.");
      return;
    }
    if(formData.Phone2!==""){
      if (!validatePhoneNumber(formData.Phone2)) {
        alert("Please enter a valid phone number.");
        return;
      }

    }
    if (!isEditMode) {
      setFormData({
        ...formData,
        Vendor_Id: 0,
      });
    }
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.post(
        `${baseAPI}Admin/AddSupplierDetail`,
        updatedForm,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      setIsEditMode(false);
      setDataPresent(true);
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  function ResetForm() {
    setFormData({
      Vendor_Id: 0,
      CompanyName: "",
      DisplayName: "",
      Phone1: "",
      Phone2: "",
      VendorGUID: "",
      CreatedBy: "Vendor",
      VendorGUID: searchParm.get("vendorID"),
    });
  }

  function AllowEditingData() {
    setIsEditMode(true);
  }

  function cancelEdit() {
    getVendorNameEmail(searchParm.get("vendorID"));
    setIsEditMode(false);
  }

  return (
    <div className="d-flex app">
      <MiniDrawer />
      {!authorized ? (
        <div
          style={{
            height: "100%",
            width: "100%",
            paddng: "63px",
            padding: "43px",
          }}
          className="row not-authrized-div"
        >
          <h1 className="col-lg-12 col-md-12 col-sm-12">
            You Are Not Authorized To Open This
          </h1>
        </div>
      ) : (
        <div id="vendorDetail_mainDiv" className="addVendorDetailMainDiv">
          <div>
            <br />
            <div className="addVendorDetail_inner_div">
              <div style={{ padding: "8px" }} className="supplier-form">
              <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div className="mt-3 px-1">
            <h1 style={{ fontSize: "24px", marginBottom: "2rem",color:"#3D3D3D" }}>
              Add Vendor | <HomeOutlinedIcon style={{color:"#6A6A6A" }} />{" "}
              <span style={{ fontSize: "20px",color:"#6A6A6A" }}>&gt; Accounts & Finance</span>
              <span style={{ fontSize: "20px",paddingLeft:"10px",color:"#6A6A6A"  }}>&gt; Vendor Registration Form</span>
            </h1>

          </div>
        </div>
                <h2>Vendor Details</h2>
                <table style={{ width: "100%" }}>
                  <tbody className="row">
                    <div className="col-lg-6 col-md-6 col-sm-6">
                      <div
                        style={{
                          margin: "25px -13px 15px",
                          display: "flex",
                          flexDirection: "row",
                        }}
                        className="row"
                      >
                        <div className="col-md-6 col-lg-6 col-sm-6">
                          <td style={{ fontWeight: "bold", color: "#6a6a6a" }}>
                            First Name
                          </td>
                          <input
                            style={{
                              border: "1px solid #5b489d",
                              color: "#6a6a6a",
                              width: "100%",
                              height: "45px",
                              padding: "8px",
                              borderRadius: "6px",
                              position: "relative",
                            }}
                            id="name_input"
                            className="vendor-input"
                            type="text"
                            name="FirstName"
                            value={vendorNameEmail.firstName}
                            placeholder="Please Enter*"
                          />
                        </div>
                        <div className="col-md-6 col-lg-6 col-sm-6">
                          <td style={{ fontWeight: "bold", color: "#6a6a6a" }}>
                            Last Name
                          </td>
                          <input
                            style={{
                              border: "1px solid #5b489d",
                              color: "#6a6a6a",
                              width: "100%",
                              height: "45px",
                              padding: "8px",
                              borderRadius: "6px",
                              position: "relative",
                            }}
                            id="name_input"
                            className="vendor-input"
                            type="text"
                            name="LastName"
                            value={vendorNameEmail.lastName}
                            placeholder="Please Enter*"
                          />
                        </div>
                      </div>

                      <tr style={{ marginTop: "-13px" }}>
                        <td>Company Name</td>
                        <input
                          className="vendor-input"
                          type="text"
                          name="CompanyName"
                          value={formData.CompanyName}
                          placeholder="Please Enter*"
                          onChange={handleChange}
                          required
                        />
                      </tr>
                      <tr style={{ marginTop: "-17px" }}>
                        <td>Display Name</td>
                        <input
                          className="vendor-input"
                          type="text"
                          name="DisplayName"
                          value={formData.CompanyName}
                          placeholder="Please Enter*"
                          required
                        />
                      </tr>
                      <tr>
                        <td>Vendor Phone 2</td>
                        {/* <LocalPhoneIcon style={{position:"absolute",left:"818px",marginTop:"11px"}} id="phone_2_icon"/> */}
                        <input
                          className="vendor-input"
                          type="text"
                          name="Phone2"
                          value={formData.Phone2}
                          placeholder="Please Enter*"
                          onChange={handleChange}
                          required
                        />
                      </tr>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6">
                      <tr>
                        <td>Vendor Email</td>

                        <input
                          className="vendor-input"
                          type="email"
                          name="VendorEmail"
                          value={vendorNameEmail.email}
                          placeholder="Please Enter*"
                        />
                      </tr>
                      <tr style={{ marginTop: "-16px" }}>
                        <td className="form-label">Vendor Category</td>
                        <select
                          className="form-control"
                          name="VendorCategory"
                          onChange={handleChange}
                          value={formData.VendorCategory}
                        >
                          <option value="0">Select an option</option>
                          {vendorCategory.map((item) => (
                            <option key={item.Tseed} value={item.Tseed}>
                              {item.Category_Name}
                            </option>
                          ))}
                        </select>
                      </tr>
                      <tr>
                        <td>Vendor Phone 1</td>
                        {/* <LocalPhoneIcon style={{position:"absolute",left:"83px",marginLeft:"48px",marginTop:"11px"}} className="phone_1_icon"/> */}
                        <input
                          className="vendor-input"
                          type="text"
                          name="Phone1"
                          value={formData.Phone1}
                          placeholder="Please Enter*"
                          onChange={handleChange}
                          required
                        />
                      </tr>
                    </div>
                  </tbody>
                </table>

                <br />
                <hr />
                <div className="reset-addSupplier-button">
                  {!dataPresent ? (
                  
                    <button
                      style={{
                        backgroundColor: "#5B489D",
                        color: "white",
                      }}
                      type="submit"
                      onClick={handleSubmit}
                    >
                      Save
                    </button>
                  ) : isEditMode ? (
                   
                    <button
                      style={{
                        backgroundColor: "#5B489D",
                        color: "white",
                      }}
                      type="submit"
                      onClick={handleSubmit}
                    >
                      Update
                    </button>
                  ) :
                
                  (
                    <button
                      style={{
                        backgroundColor: "#5B489D",
                        color: "white",
                      }}
                      type="submit"
                      onClick={AllowEditingData}
                    >
                      Edit
                    </button>
                  )}
                  {filledData === null ? (
                    
                      
                    <button
                      style={{
                        backgroundColor: "white",
                        color: "red",
                        border: "none",
                      }}
                      onClick={ResetForm}
                    >
                      Reset
                    </button>
                  ) :
              (
                   
                    <button
                      style={{
                        backgroundColor: "white",
                        border: "none",
                        color: "red",
                      }}
                      onClick={cancelEdit}
                    >
                      Cancel
                    </button>
                  )}
                </div>
              </div>
            </div>
            <br />
          </div>

          <div
            className="nav-main-div row"
            style={{
              display: "flex",
              marginTop: "-17px",
              marginBottom: "41px",
              height: "70px",
            }}
          >
            <div
              style={{
                borderBottom: "1px solid rgb(189 172 172)",
                display: "flex",
                widt: "100%",
                marginTop: "-23px",
                marginBottom: "41px",
                height: "103px",
              }}
              className="inner_div col-md-12 col-lg-12 col-sm-6"
            >
              <div className="fourHeadings" style={{ display: "flex" }}>
                <h4
                  style={{
                    color: showDetailForms.AddressForm ? "#5B489D" : "#6A6A6A",
                    borderBottom: showDetailForms.AddressForm
                      ? "3px solid #5B489D"
                      : "none",
                    paddingBottom: "45px",
                    transition: "color 0.3s ease",

                  }}
                  onClick={() => showClickedForm("AddressForm")}
                >
                  Address
                </h4>
                <h4
                  style={{
                    color: showDetailForms.OtherDetailsForm
                      ? "#5B489D"
                      : "#6A6A6A",
                    borderBottom: showDetailForms.OtherDetailsForm
                      ? "3px solid #5B489D"
                      : "none",
                    paddingBottom: "45px",
                    transition: "color 0.3s ease",

                  }}
                  onClick={() => showClickedForm("OtherDetailsForm")}
                >
                  Other Details
                </h4>
                <h4
                  style={{
                    color: showDetailForms.BankDetailsForm
                      ? "#5B489D"
                      : "#6A6A6A",
                    borderBottom: showDetailForms.BankDetailsForm
                      ? "3px solid #5B489D"
                      : "none",
                    paddingBottom: "45px",
                    transition: "color 0.3s ease",

                  }}
                  onClick={() => showClickedForm("BankDetailsForm")}
                >
                  Bank Details
                </h4>
                <h4
                  style={{
                    color: showDetailForms.ContactDetailsForm
                      ? "#5B489D"
                      : "#6A6A6A",
                    borderBottom: showDetailForms.ContactDetailsForm
                      ? "3px solid #5B489D"
                      : "none",
                    paddingBottom: "45px",
                    transition: "color 0.3s ease",

                  }}
                  onClick={() => showClickedForm("ContactDetailsForm")}
                >
                  Contact Details
                </h4>
                <h4
                  style={{
                    color: showDetailForms.TermsForm ? "#5B489D" : "#6A6A6A",
                    borderBottom: showDetailForms.TermsForm
                      ? "3px solid #5B489D"
                      : "none",
                    paddingBottom: "45px",
                    transition: "color 0.3s ease",

                  }}
                  onClick={() => showClickedForm("TermsForm")}
                >
                  Terms & Conditions
                </h4>
              </div>
            </div>
          </div>
          <div className="d-flex">
            {showDetailForms.AddressForm ? (
              <AddVendorAddress
                setShowDetailForms={setShowDetailForms}
                userType={"admin"}
              />
            ) : null}
            {showDetailForms.OtherDetailsForm ? (
              <AddVendorOtherDetails
                setShowDetailForms={setShowDetailForms}
                userType={"admin"}
              />
            ) : null}
            {showDetailForms.BankDetailsForm ? (
              <AddVendorBankDetails
                setShowDetailForms={setShowDetailForms}
                userType={"admin"}
              />
            ) : null}
            {showDetailForms.ContactDetailsForm ? (
              <AddVendorContactDetails
                setShowDetailForms={setShowDetailForms}
                userType={"admin"}
              />
            ) : null}
            {showDetailForms.TermsForm ? (
              <VendorTermsConditions
                setShowDetailForms={setShowDetailForms}
                name={vendorNameEmail.firstName}
                user={"admin"}
                company={formData.CompanyName}
                formSubmitted={formSubmitted}
              />
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
};

export default AddVendorDetails;
